import React from "react";

import {mb, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ShowMoreWrapperWithLineClamp} from "../../../atoms/ShowMoreWrapperWithLineClamp";
import {IVariablesStore} from "../../../variables/reducers/variables_reducer";
import {VendorType} from "../../helpers/VendorType";
import {IVendorDetailStatsRegions} from "../../types/IVendorDetailStatsRegions";
import {VendorDetailGeneratedDescription} from "./VendorDetailGeneratedDescription";
import {VendorDetailRecommendation} from "./VendorDetailRecommendation";

interface IProps {
    vendor: {
        description: string;
        headquarters: {
            type: 1 | 2;
            address: string;
            region: {
                id: number;
                name: string;
                name_declension_where: string;
            };
        };
        name: string;
        recommendation: {
            pzfd_member: number | null;
            stats: {
                label: number;
                value: number;
            }[];
        } | null;
        stats: {
            offers_count_for_sale: number;
            properties_commercials_area_max: number;
            properties_commercials_area_min: number;
            properties_flats_area_max: number;
            properties_flats_area_min: number;
            properties_houses_area_max: number;
            properties_houses_area_min: number;
            regions: Record<string, IVendorDetailStatsRegions>;
        };
        type: VendorType;
    };
    variables: IVariablesStore;
    flatsOffers: {
        name: string;
    }[];
    housesOffers: {
        name: string;
    }[];
    commercialsOffers: {
        name: string;
    }[];
}

export const VendorDetailDescription = (props: IProps) => {
    const {vendor, variables, flatsOffers, housesOffers, commercialsOffers} = props;
    const shouldGenerateAdditionalDescription = !vendor.description || vendor.description.length < 300;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(5), onDesktop(mb(7))]}>
                Informacje o nas
            </Text>

            {vendor.recommendation && <VendorDetailRecommendation vendor={vendor} variables={variables} />}

            <ShowMoreWrapperWithLineClamp maxLinesToShow={8}>
                {vendor.description && (
                    <>
                        {vendor.description.split("\n").map((item, key) => (
                            <Text key={key} as="p" variant="body_copy_2" mb="0.4rem">
                                {item.trim()}
                            </Text>
                        ))}
                    </>
                )}

                {shouldGenerateAdditionalDescription && (
                    <VendorDetailGeneratedDescription
                        vendor={vendor}
                        variables={variables}
                        flatsOffers={flatsOffers}
                        housesOffers={housesOffers}
                        commercialsOffers={commercialsOffers}
                    />
                )}
            </ShowMoreWrapperWithLineClamp>
        </>
    );
};
import React from "react";

import {mb, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ShowMoreWrapperWithLineClamp} from "../../../atoms/ShowMoreWrapperWithLineClamp";
import {IVariablesStore} from "../../../variables/reducers/variables_reducer";
import {VendorType} from "../../helpers/VendorType";
import {IVendorDetailStatsRegions} from "../../types/IVendorDetailStatsRegions";
import {VendorDetailGeneratedDescription} from "./VendorDetailGeneratedDescription";
import {VendorDetailRecommendation} from "./VendorDetailRecommendation";

interface IProps {
    vendor: {
        description: string;
        headquarters: {
            type: 1 | 2;
            address: string;
            region: {
                id: number;
                name: string;
                name_declension_where: string;
            };
        };
        name: string;
        recommendation: {
            pzfd_member: number | null;
            stats: {
                label: number;
                value: number;
            }[];
        } | null;
        stats: {
            offers_count_for_sale: number;
            properties_commercials_area_max: number;
            properties_commercials_area_min: number;
            properties_flats_area_max: number;
            properties_flats_area_min: number;
            properties_houses_area_max: number;
            properties_houses_area_min: number;
            regions: Record<string, IVendorDetailStatsRegions>;
        };
        type: VendorType;
    };
    variables: IVariablesStore;
    flatsOffers: {
        name: string;
    }[];
    housesOffers: {
        name: string;
    }[];
    commercialsOffers: {
        name: string;
    }[];
}

export const VendorDetailDescription = (props: IProps) => {
    const {vendor, variables, flatsOffers, housesOffers, commercialsOffers} = props;
    const shouldGenerateAdditionalDescription = !vendor.description || vendor.description.length < 300;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(5), onDesktop(mb(7))]}>
                Informacje o nas
            </Text>

            {vendor.recommendation && <VendorDetailRecommendation vendor={vendor} variables={variables} />}

            <ShowMoreWrapperWithLineClamp maxLinesToShow={8}>
                {vendor.description && (
                    <>
                        {vendor.description.split("\n").map((item, key) => (
                            <Text key={key} as="p" variant="body_copy_2" mb="0.4rem">
                                {item.trim()}
                            </Text>
                        ))}
                    </>
                )}

                {shouldGenerateAdditionalDescription && (
                    <VendorDetailGeneratedDescription
                        vendor={vendor}
                        variables={variables}
                        flatsOffers={flatsOffers}
                        housesOffers={housesOffers}
                        commercialsOffers={commercialsOffers}
                    />
                )}
            </ShowMoreWrapperWithLineClamp>
        </>
    );
};
